// import * as idb from 'idb';
import { MaybePromise } from '@/utils/types';
import type { IDBPDatabase } from 'idb';
import omit from 'lodash/omit';
import React, { useEffect, useState } from 'react';
import { logger } from '../logger';

const Store = React.createContext<IDBPDatabase<any> | null>({} as any);
Store.displayName = 'DIdb';

export const useIdb = () => React.useContext(Store);

export const IdbProvider = ({ children }: any) => {
    const [instance, setInstance] = useState<IDBPDatabase<any> | null>(null);

    useEffect(() => {
        if (!instance && window.indexedDB) {
            import('idb').then(async idb => {
                function openDb() {
                    const CURRENT_VERSION = 4;
                    return idb.openDB('mydb', CURRENT_VERSION, {
                        async upgrade(db, oldVersion, newVersion: number, transaction) {
                            const versionUpgrades: Record<number, () => MaybePromise<void>> = {
                                1: () => {
                                    db.createObjectStore('drafts', { keyPath: 'id' });
                                },
                                2: () => {
                                    db.createObjectStore('v2drafts', { keyPath: 'id' });
                                },
                                3: () => {
                                    db.createObjectStore('draftsAgent', { keyPath: 'id' });
                                },
                                4: async () => {
                                    db.createObjectStore('v2draftsAgent', { keyPath: 'id' });
                                    try {
                                        const draftsAgentStore = transaction.objectStore('draftsAgent');
                                        const v2draftsAgentStore = transaction.objectStore('v2draftsAgent');

                                        const drafts = await draftsAgentStore.getAll();
                                        drafts.forEach(draft => {
                                            v2draftsAgentStore.put({
                                                ...omit(draft, ['agentInstructions', 'agentGrounding']),
                                                llm: {
                                                    instructions: draft.agentInstructions,
                                                    template: draft.agentGrounding,
                                                },
                                            });
                                        });
                                    } catch (error) {
                                        logger.error('Error upgrading db to version 4', error);
                                    }
                                },
                            };

                            for (let i = oldVersion + 1; i < newVersion + 1; i++) {
                                await versionUpgrades[i]?.();
                            }
                        },
                        blocked() {
                            console.log('blocked');
                        },
                        blocking() {
                            console.log('blocking');
                        },
                        terminated() {
                            console.log('terminated');
                        },
                    });
                }

                openDb()
                    .then(setInstance)
                    .catch(async () => {
                        await idb.deleteDB('mydb');
                        await openDb().then(setInstance);
                    });
            });
        }
    }, [instance, window.indexedDB]);

    return <Store.Provider value={instance}>{children}</Store.Provider>;
};
